(function () {
    window['feHPEB2C'].log('FE: 4036: start')
    if (typeof feProjectId === 'undefined') {
        var feProjectId = 'FE:4036';
    }

    let SelectorsDictionary = {
        ArticleRows: "article.hpe-product-grid:not(.hpe-block-overflow)",
        TileElement: "div.hpeit-campaignPage-tab-content",
        TileTextToHide: "p.hpeit-campaign-card-text,div.hpeit-campaign-card-body > div > div > span.hpeit-text-block",
        ShowSpecLink: "a.hpeit-campaign-specifications"
    }
    const logo_url = 'https://fe-hpe-public.s3.us-east-1.amazonaws.com/images/AMD_E_Blk_RGB.png';

    /**
     * Split a product name string into series name and product details
     * The end of the Series name can take patterns like: Gen##, Gen## Plus, Gen## Plus V#, G##
     */
    function splitStringIntoSeriesAndProductName(str) {
        const words = str.split(' ');
        let genIndex = -1;

        // Find the index of the word that starts with "Gen"
        for (let i = 0; i < words.length; i++) {
            if (words[i].startsWith('Gen')) {
                genIndex = i;

                // Check if "Gen" is followed by "Plus" or "Plus V#"
                if (i + 1 < words.length && words[i + 1] === 'Plus') {
                    genIndex = i + 1;

                    // Check for "Plus V#" pattern
                    if (i + 2 < words.length && words[i + 2].toUpperCase().startsWith('V')) {
                        genIndex = i + 2;
                    }
                }
                break;
            } else if (words[i].toUpperCase().startsWith('G') && words[i].length === 3 && !isNaN(parseInt(words[i].slice(1)))) {
                genIndex = i;
                break;
            }
        }

        // Split the string into series and product name
        let seriesName = '';
        let productName = '';

        if (genIndex !== -1) {
            seriesName = words.slice(0, genIndex + 1).join(' ');
            productName = words.slice(genIndex + 1).join(' ');
        } else {
            // If no "Gen" found, treat the whole string as series name
            seriesName = str;
        }

        return {seriesName, productName};
    }

    function reformatTileHeadings() {
        jQuery('div.hpeit-card-campaign h4').each(function (index, el) {
            const $el = jQuery(el);
            const fullText = $el.text().trim();
            const {seriesName, productName} = splitStringIntoSeriesAndProductName(fullText);

            if (productName) {
                $el.html(`<span class="fe-4036-series-name">${seriesName}</span> <span class="fe-4036-product-details">${productName}</span>`);
            }
        });
    }

// for phase 2 hide text
    // function hideTextInTile(tile) {
    //     // Find and hide text elements in the tile
    //     jQuery(tile).find(SelectorsDictionary.TileTextToHide).hide();
    // }

    function addLogosToHeading() {
        jQuery('div.hpeit-pdp-container div.content')
            .addClass('fe-4036-has-logo')
            .css('position', 'relative')
            .append(`
                <div class="fe-4036-logos"> 
                    <img src="${logo_url}" alt="AMD Logo" />
                </div>
            `);
    }

    /**
     * for phase 2 hide text
     */
    // function handleArticleRows() {
    //     jQuery(SelectorsDictionary.ArticleRows).toArray().forEach((row, index) => {
    //         let tiles = jQuery(row).find(SelectorsDictionary.TileElement).toArray();
    //         tiles.forEach(tile => {
    //             hideTextInTile(tile);
    //         });
    //     });
    // }

    function onPageReady() {
        try {
            // Add campaign page CSS class
            jQuery('body').addClass('fe-4036-campaign-page');

            // Add logo to heading
            addLogosToHeading();

            // Handle article rows
            //   handleArticleRows();//was for phase 2 hide text

            // Reformat tile headings to separate series name from product details
            reformatTileHeadings();

        } catch (er) {
            console.log('FE: 4036: error', er)
        }
    }

    window.feUtils.waitForConditions({
        conditions: ['body', () => {
            return window['FEi18n']?.isReady()
        }],
        activity: feProjectId,
        callback: onPageReady,
    })

})();